"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Underline: function() {
        return Underline;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Underline = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M9 4.125C9 3.82663 8.88147 3.54048 8.6705 3.3295C8.45952 3.11853 8.17337 3 7.875 3C7.57663 3 7.29048 3.11853 7.0795 3.3295C6.86853 3.54048 6.75 3.82663 6.75 4.125V11.25C6.75 12.6424 7.30312 13.9777 8.28769 14.9623C9.27226 15.9469 10.6076 16.5 12 16.5C13.3924 16.5 14.7277 15.9469 15.7123 14.9623C16.6969 13.9777 17.25 12.6424 17.25 11.25V4.125C17.25 3.82663 17.1315 3.54048 16.9205 3.3295C16.7095 3.11853 16.4234 3 16.125 3C15.8266 3 15.5405 3.11853 15.3295 3.3295C15.1185 3.54048 15 3.82663 15 4.125V11.25C15 12.0456 14.6839 12.8087 14.1213 13.3713C13.5587 13.9339 12.7956 14.25 12 14.25C11.2044 14.25 10.4413 13.9339 9.87868 13.3713C9.31607 12.8087 9 12.0456 9 11.25V4.125ZM7.125 18.75C6.82663 18.75 6.54048 18.8685 6.3295 19.0795C6.11853 19.2905 6 19.5766 6 19.875C6 20.1734 6.11853 20.4595 6.3295 20.6705C6.54048 20.8815 6.82663 21 7.125 21H16.875C17.1734 21 17.4595 20.8815 17.6705 20.6705C17.8815 20.4595 18 20.1734 18 19.875C18 19.5766 17.8815 19.2905 17.6705 19.0795C17.4595 18.8685 17.1734 18.75 16.875 18.75H7.125Z",
        fill: "currentColor"
    })
}), "Underline");
const _default = Underline;
